import React from 'react';
import ErrorView from "../ErrorView.js";
import LoadingView from "../LoadingView.js";
import LoadingScreen from "../../screens/support/LoadingScreen.js";
import ErrorScreen from "../../screens/support/ErrorScreen.js";
import BlockerHookRunner from "./BlockerHookRunner.js";
/**
 * This will block rendering of the supplied view until
 * all hooks have completed.
 * 
 */
import { jsx as _jsx } from "react/jsx-runtime";
export default class Blocker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      done: false
    };
  }
  componentDidMount() {
    this.load();
  }
  componentWillUnmount() {
    if (this.runner) {
      this.runner.shutdown();
    }
  }
  async load() {
    this.runner = new BlockerHookRunner(this.props);
    try {
      const res = await this.runner.run();
      if (res.done) {
        this.setState({
          done: true
        });
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      this.setState({
        done: true,
        error
      });
    }
  }
  render() {
    const {
      error,
      done
    } = this.state;
    const {
      loadingComponent,
      errorComponent,
      loadingProps,
      errorProps,
      render,
      small,
      children
    } = this.props;
    const Error = errorComponent || (small ? ErrorView : ErrorScreen);
    const Loading = loadingComponent || (small ? LoadingView : LoadingScreen);
    if (error) {
      return /*#__PURE__*/_jsx(Error, {
        ...errorProps,
        error: error
      });
    }
    if (!done) {
      return /*#__PURE__*/_jsx(Loading, {
        ...loadingProps
      });
    }
    return typeof render === 'function' ? render() : children;
  }
}